import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ComponentStatus } from '../student-slip-modal.store';

@Component({
  selector: 'app-slip-component-status',
  templateUrl: './slip-component-status.component.html',
  styleUrls: ['./slip-component-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass]
})
export class SlipComponentStatusComponent {
  class: ComponentStatus;
  legend: string;
  private statusBacking: ComponentStatus;
  @Input()
  public set status(value: ComponentStatus) {
    this.statusBacking = value;
    this.class = value;
    this.legend = value.toLocaleUpperCase().replace('-', ' ');
  }
  public get status(): ComponentStatus {
    return this.statusBacking;
  }
}
